import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';

// Interceptor global de fetch para inyectar token JWT en llamadas al backend
const originalFetch = window.fetch;
window.fetch = async function (url, options = {}) {
  const token = localStorage.getItem('token');
  if (token) {
    const urlStr = url.toString();
    // Evitar inyectar token si la petición es a un dominio externo no relacionado
    const isExternal = (urlStr.startsWith('http://') || urlStr.startsWith('https://')) &&
                       !urlStr.includes('localhost') &&
                       !urlStr.includes('127.0.0.1') &&
                       !urlStr.includes('/api/');
    
    if (!isExternal) {
      options.headers = options.headers || {};
      if (options.headers instanceof Headers) {
        if (!options.headers.has('Authorization')) {
          options.headers.set('Authorization', `Bearer ${token}`);
        }
      } else {
        options.headers = {
          'Authorization': `Bearer ${token}`,
          ...options.headers
        };
      }
    }
  }
  const response = await originalFetch(url, options);
  if (response.status === 401) {
    const urlStr = url.toString();
    const isAuthEndpoint = urlStr.includes('/auth/login') || urlStr.includes('/auth/verify-2fa');
    if (!isAuthEndpoint) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
        window.location.href = '/login';
      }
    }
  }
  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
